import {
  CakeSlice,
  CupSoda,
  Drumstick,
  Hamburger,
  Package,
  Pizza,
  Salad,
  Sandwich,
  Soup,
  UtensilsCrossed,
  type LucideIcon,
} from "lucide-react";
import { FriesIcon } from "../components/illustrations/FriesIcon";
import { normalizeText } from "./format";

/** Palavra-chave (sem acento) → ícone. A primeira que bater vence. */
const CATEGORY_ICONS: Array<[keyword: string, icon: LucideIcon]> = [
  ["hamb", Hamburger],
  ["burger", Hamburger],
  ["batata", FriesIcon],
  ["acompanh", FriesIcon],
  ["porc", FriesIcon],
  ["bebida", CupSoda],
  ["drink", CupSoda],
  ["suco", CupSoda],
  ["refri", CupSoda],
  ["pizza", Pizza],
  ["frango", Drumstick],
  ["sobremesa", CakeSlice],
  ["doce", CakeSlice],
  ["combo", Package],
  ["sanduiche", Sandwich],
  ["lanche", Sandwich],
  ["massa", Soup],
  ["salada", Salad],
];

export const iconForCategory = (category: string): LucideIcon => {
  const key = normalizeText(category);
  return CATEGORY_ICONS.find(([keyword]) => key.includes(keyword))?.[1] ?? UtensilsCrossed;
};
